import React, { useState } from 'react';
import CheckBox from '../../CheckBox';
import { SaveButton } from '../../styled';

const SwornDeclaration = (props: any) => {
  const { handleSend } = props;
  const [isChecked, setIsChecked] = useState(false);

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className="container__main_sworn" data-testid="cpm-swon-declaration">
      <div className="container__sworndeclaration">
        <h1>
          Confirma que toda la información es verdadera, leyendo y aceptando los
          siguientes términos.{' '}
          <strong> Realizar este paso es obligatorio.</strong> <br /> <br />{' '}
          Declaro bajo juramento que toda la información contenida en la
          presente declaración jurada se ajusta a la realidad y es posible su
          verificación en caso se requiera. Asimismo, me comprometo a brindar
          cualquier documento que la universidad considere necesario a fin de
          sustentar la información indicada en la presente declaración jurada.
          En caso de consignar información falsa, incompleta o inexacta, me
          someto a las sanciones establecidas en el Reglamento de Disciplina,
          así como en otros reglamentos de la Universidad Tecnológica del Perú.
        </h1>
        <div className="container__accept_statement">
          {/* <label>
            <input type="checkbox" id="cbox1" value="first_checkbox" /> Este es
            mi primer checkbox
          </label> */}
          {/* <Checkbox isChecked={isChecked} handleOnChange={handleOnChange} /> */}
          <CheckBox
            value="1"
            firstLabel="Acepto haber leído la Declaración Jurada 
            y estar de acuerdo."
            handleOnChange={handleOnChange}
          />
        </div>
      </div>
      <SaveButton
        disabled={isChecked === undefined ? true : !isChecked}
        onClick={handleSend}
        data-testid="cmp-save-bse-form"
      >
        Aceptar
      </SaveButton>
    </div>
  );
};

export default SwornDeclaration;
